/**
 * RBAC helper for manifest routes. Wire `getUserPermissions()` to your auth
 * source (e.g. API / localStorage) when permissions are enforced server-side.
 */
export function getUserPermissions(): string[] {
  try {
    const raw = localStorage.getItem('user_permissions')
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? (parsed as string[]) : []
  } catch {
    return []
  }
}

export function hasAccess(
  required: string[] | undefined,
  userPermissions: string[]
): boolean {
  if (!required || required.length === 0) return true
  return required.every((p) => userPermissions.includes(p))
}
